var _style, _g, _g2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSouffleur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 374.1 251.7",
    style: {
      enableBackground: "new 0 0 374.1 251.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#00FF00;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M226.7,164.6L150.3,241c21.1,21.1,55.3,21.1,76.4,0S247.8,185.7,226.7,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M263.9,108.9l-76.3,76.4c-21.1-21.1-21.1-55.3,0-76.4S242.8,87.8,263.9,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M260.1,148.8v108c29.8,0,54-24.2,54-54S289.9,148.8,260.1,148.8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "312.5,148.8 353,256.8 393.5,148.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 317,
    height: 237,
    xlinkHref: "2CAF650DDF1E2A3A.png",
    transform: "matrix(1.4052 0 0 1.4052 -25.0931 -36.5852)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 317,
    height: 237,
    xlinkHref: "2CAF650DDF1E2A3E.png",
    transform: "matrix(1.4052 0 0 1.4052 -41.9553 -42.2059)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M125.6,112.1L18.3,219.5c29.6,29.6,77.7,29.6,107.4,0S155.3,141.8,125.6,112.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.9,33.9L70.7,141.2C41,111.6,41,63.5,70.7,33.9S148.2,4.2,177.9,33.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.6,89.9v151.8c41.9,0,75.9-34,75.9-75.9S214.4,89.9,172.6,89.9z"
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "246.2,89.9 303.1,241.7 360,89.9  "
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M228.1,32.5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSouffleur);
export default __webpack_public_path__ + "static/media/logoSouffleur.c2e3a9c35e7bf4afbf0b08fd73a8db05.svg";
export { ForwardRef as ReactComponent };